// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"897420b2","419":"86fd64f7","563":"b628c199","942":"1c9d5356"}[chunkId] + ".chunk.js";
};